import { useContext } from 'react';
import { BugsnagReportingContext } from './BugsnagReportingProvider';

/**
 * Report any message to bugsnag.  If no client is available, this will do nothing.
 */
export const useReportInfoToBugsnag = () => {
  return useContext(BugsnagReportingContext).reportInfoToBugsnag;
};

/**
 * Report any error to bugsnag.  If no client is available, this will do nothing.
 */
export const useReportErrorToBugsnag = () => {
  return useContext(BugsnagReportingContext).reportErrorToBugsnag;
};
